<template>
    <div id="">
    <main>
        <video autoplay loop muted playsinline class="background-video">
                <source src="assets/video/loop.mp4" type="video/mp4" style="opacity: 0.8;" />
                Your browser does not support the video tag.
        </video>
        <div class="content-overlay">
            <div class="p-t-b-100 height-full page-background" style="background-color: #98CC5A; opacity: 0.9;">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-7 mx-md-auto" style="padding-top: 30px;" >
                            <div class="card shadow1" style="background-color: #ecf0f1">
                                <div class="card-body" style="background-color: #ecf0f1">
                                    <div class="green-text text-center ">
                                        <a href="https://startwinsherbal.com/"><img class="img-responsive" src="/assets/img/logo2b.png" width="300px" height="auto" alt=""></a><br>
                                        <img class="img-responsive" src="/assets/img/protection1.png" style= "max-width:100px" alt="">
                                        <p class=" font-weight-bold">2FA Authentication (Enter code sent to your mail)</p>
                                    </div>
                                    <form @submit.prevent="submit()">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="form-group has-icon shadow1"><i class="icon-lock"></i>
                                                    <input required type="password" v-model="form.code" id="password-field" class="form-control form-control-lg no-b" placeholder="Enter Code">
                                                    <span @click="viewPass()" id="eye" class="green-text field-icon toggle-password mr-3 icon-eye3" style="text-decoration: none"></span>
                                                </div>
                                            </div>

                                            <!-- <div class="col-lg-6">
                                                <span v-if="submitting" class="btn btn-warning btn-lg btn-block">...</span>
                                                <span v-else @click="sendCode()" class="btn btn-warning btn-lg btn-block"><i class="icon-check-square-o mr-2"></i>Resend Code</span>
                                            </div> -->
                                            
                                            <div class="col-lg-12">
                                                <span v-if="submitting" class="btn btn-success btn-lg btn-block">...</span>
                                                <input v-else  type="submit" class="btn btn-success btn-lg btn-block" value="Authenticate">
                                            </div>

                                            <div class="col-md-12 mt-3">
                                                <div class="forget-pass green-text text-center">
                                                    <span v-if="submitting" class="">...</span>
                                                    <a v-else class="green-text" href="#" @click="sendCode()" style="text-decoration:none">
                                                        <span class="font-weight-bold">Resend Confirmation Code</span>
                                                    </a>
                                                </div>    
                                            </div>

                                            
                                            <div class="col-md-12">
                                                <div class="text-center">
                                                    
                                                    <p class="green-text mt-3">Don't Have an Account?
                                                        <router-link :to="{name:'user-login'}" class="font-weight-bold" style= "color:#2E671A; text-decoration: none;"> <b>Proceed to login!</b></router-link>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                    <!-- <div class="row">
                                        <p class="forget-pass text-white text-center"> Login Instead ?
                                            <br><router-link :to="{name:'user-login'}"> <b>Login</b> </router-link>
                                        </p>
                                    </div>  -->
                                </div>
                            </div>        
                        </div>
                    </div>
                </div>
            </div>
        </div>    
    </main>
</div>
</template>
<style>
.page-background {
    background-color: #ded8c7;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

    .field-icon {
    float: right;
    margin-left: -30px;
    margin-top: -35px;
    position: relative;
    z-index: 2;
    font-size: 20px;
}
</style>
<script>
import {mapActions,mapState} from 'vuex'
import { notification } from '@/util/notification'
export default {
    name:'user-two-factor-auth',
    data(){
        return{
            form:{
                code:null,
                email: this.$route.query.email,
                user_type:'user'
            },
            mailForm:{
                email: this.$route.query.email,
                user_type:'user'
            },
            showPass:false
        }
    },

    computed:{
        ...mapState({
            submitting:state=>state.submitting
        })
    },

    created(){
        if(!this.mailForm.email){
            notification.warning("Invalid email address, please return to previous page")
            return
        }
        this.sendTwoFactorAuthMail(this.mailForm)
    },
    
    methods:{
        ...mapActions('authStore',['sendTwoFactorAuthMail','twoFactorAuth']),

        submit(){
            if(!this.form.email){
                notification.warning("Invalid email address, please return to previous page")
                return
            }
            this.twoFactorAuth(this.form)
        },

        sendCode(){
            if(!this.mailForm.email){
                notification.warning("Invalid email address, please return to previous page")
                return
            }
            this.sendTwoFactorAuthMail(this.mailForm)
        },
        viewPass(){
            let pass = document.getElementById('password-field');
            this.showPass = !this.showPass
            if(this.showPass){
                pass.type = 'text'
            }else{
                pass.type = 'password'
            } 
        }
    }
}
</script>